<template>
    <regie-aktiv />
</template>

<script>

    import RegieAktiv from "../components/regie/Regie";

    export default {
        name: "Regie",
        components: {RegieAktiv},
        metaInfo: {
            title: "Regie",
            meta: [
                {name: 'description', content: 'Aus welcher Regie besteht unser Verein'}
            ]
        }
    }
</script>